import axios from 'axios';

import { EMBEDDED_DASHBOARD } from 'RestAPIs/endpoints';

type PayloadResponse = {
  embedToken: any;
  embedReport: any;
};

export const getEmbeddedDashboardConfig = () =>
  axios.get<PayloadResponse>(EMBEDDED_DASHBOARD);
